import { createReducer } from "redux-act";

import * as a from "../actions/ide";

const getDefaultState = () => ({
  currentRepository: null,
  isCommiting: false,
  isLoading: false,
  currentProject: null,
  activeCommitId: null,
  isLoadingRepositories: false,
  isCommitingSuccess: null,
  userRepositoryLoaded: false,
  isCommitLoadingSuccess: null,
});

export default () =>
  createReducer(
    {
      [a.addCommit]: (state) => {
        return {
          ...state,
          isCommiting: true,
          isCommitingSuccess: null,
        };
      },
      [a.addCommitError]: (state) => ({
        ...state,
        isCommiting: false,
        isCommitingSuccess: false,
      }),
      [a.receivedResponseOnCommit]: (state, payload) => {
        const { repository, commit } = payload;
        const previousCommits = state.currentRepository && state.currentRepository?.id === repository.id
            ? state.currentRepository.commits || []
            : [];

        const mergedCommits = [...previousCommits];
        if (!mergedCommits.some((c) => c.id === commit.id)) {
          mergedCommits.unshift(commit);
        }

        const repositoryWithCommits = {
          ...repository,
          commits: mergedCommits,
        };

        return {
          ...state,
          isCommiting: false,
          isCommitingSuccess: true,
          activeCommitId: commit.id,
          currentRepository: repositoryWithCommits,
        };
      },
      [a.getProjectByCommit]: (state) => {
        return {
          ...state,
          isLoading: true,
          isCommitLoadingSuccess: null,
        };
      },
      [a.loadProjectByCommitError]: (state) => {
        return {
          ...state,
          isLoading: false,
        };
      },
      [a.receivedProjectByCommit]: (state, payload) => {
        const { commitId, project } = payload;
        return {
          ...state,
          currentProject: project,
          activeCommitId: commitId,
          isCommitLoadingSuccess: true,
          isLoading: false,
        };
      },
      [a.clearCurrentProject]: (state) => {
        return {
          ...state,
          currentProject: null,
        };
      },
      [a.getMyRepository]: (state) => {
        return {
          ...state,
          isLoadingRepositories: true,
          userRepositoryLoaded: false,
        };
      },
      [a.receivedMyRepository]: (state, payload) => {
        const { repository } = payload;
        return {
          ...state,
          currentRepository: repository,
          isLoadingRepositories: false,
          userRepositoryLoaded: true,
        };
      },
      [a.getMyRepositoryError]: (state) => ({
        ...state,
        isLoadingRepositories: false,
      }),
      [a.setActiveCommit]: (state, payload) => {
        const { commitId } = payload;
        return {
          ...state,
          activeCommitId: commitId,
        };
      },

      [a.getProjectByRepository]: (state) => {
        return {
          ...state,
          isLoading: true,
        };
      },
      [a.receivedProjectByRepository]: (state, payload) => {
        const { project } = payload;
        return {
          ...state,
          currentProject: project,
          isLoading: false,
        };
      },
      [a.getProjectByRepositoryError]: (state) => {
        return {
          ...state,
          isLoading: false,
        };
      },
      [a.getRepository]: (state) => {
        return {
          ...state,
          isLoadingRepositories: true,
          userRepositoryLoaded: false,
        };
      },
      [a.receivedRepository]: (state, payload) => {
        const { repository } = payload;
        return {
          ...state,
          currentRepository: repository,
          isLoadingRepositories: false,
          userRepositoryLoaded: true,
        };
      },
      [a.getRepositoryError]: (state) => ({
        ...state,
        isLoadingRepositories: false,
        userRepositoryLoaded: true,
      }),
    },
    getDefaultState()
  );
